import medusa from '@/scripts/medusa';

export default {
  // When the bound element is inserted into the DOM...
  inserted(el) {
    medusa.ref.pushToTarget('simpleParallax', el);
  },
  unbind(el) {
    medusa.ref.pullFromTarget('simpleParallax', el);
  },
};
